import React from 'react';
import { Modal, Spin, Result } from 'antd';
import { Ticket } from '../types';
import { useQuery } from '@tanstack/react-query';
import { fetchCallInformation } from '@/api/logs';
import { CallDetailsView } from './CallDetailsView';
import { PhoneOutlined } from '@ant-design/icons';

interface Props {
	ticket: Ticket | null;
	shareableLink: string | null;
	onClose: () => void;
}

export const CallDetailsModal: React.FC<Props> = ({ ticket, shareableLink, onClose }) => {
	const {
		data: callLogResponse,
		isPending,
		isError,
	} = useQuery({
		queryKey: ['callLogDetailsByLink', shareableLink],
		queryFn: () => fetchCallInformation(shareableLink || ''),
		enabled: !!ticket && !!shareableLink,
	});

	return (
		<Modal
			open={!!ticket}
			onCancel={onClose}
			footer={null}
			width={800}
			destroyOnHidden
			title={
				<div className="flex items-center gap-3">
					<div className="bg-blue-50 p-2 rounded-lg">
						<PhoneOutlined className="text-blue-600 text-base" />
					</div>
					<div>
						<div className="text-lg font-semibold text-gray-800">Call Details</div>
						<div className="text-sm text-gray-500">{`${ticket?.callerPhone}`}</div>
					</div>
				</div>
			}
		>
			{isPending && (
				<div className="flex justify-center p-12">
					<Spin size="large" />
				</div>
			)}
			{isError && <Result status="error" title="Failed to load call details." />}
			{callLogResponse?.data && <CallDetailsView callLog={callLogResponse.data} />}
		</Modal>
	);
};
